module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"header":{"name":"Item","current_reward":"Current Reward","max_reward":"Max Reward"},"footer":{"name":"Total"}}}')
  delete Component.options._Ctor
}
